import React from 'react';
import { Field } from 'react-final-form';
import { TextArea } from '../Input';

const TextAreaField = ({
  title,
  name,
  validate,
  type,
  placeholder,
  className,
  autoFocus,
  innerRef,
  required,
  disabled,
  maxLength,
  showResizeIcon,
  showCharsCount,
  minRows,
  enablePreviewModal,
  dataTestId
}) => (
  <Field
    name={name}
    validate={validate}
    type={type}
    render={({ input, meta }) => (
      <TextArea
        {...input}
        error={meta.touched && meta.error}
        title={title}
        maxLength={maxLength}
        placeholder={placeholder}
        className={className}
        innerRef={innerRef}
        required={required}
        disabled={disabled}
        autoFocus={autoFocus}
        showResizeIcon={showResizeIcon}
        minRows={minRows}
        showCharsCount={showCharsCount}
        enablePreviewModal={enablePreviewModal}
        dataTestId={dataTestId}
      />
    )}
  />
);

export default TextAreaField;
